import React, { useContext } from "react";
import AuthContext from "../../context/auth/AuthContext";
import SidebarNavigation from "./SidebarNavigation";

function Menu() {
  const { appConfig, isEmployee, modules } = useContext(AuthContext);
  const branding = appConfig?.branding;

  return (
    <aside className="fixed inset-y-0 left-0 z-20 flex h-screen w-[250px] flex-col overflow-hidden bg-primary p-4 text-stone-200">
      <SidebarNavigation
        branding={branding}
        modules={modules}
        isEmployee={isEmployee}
      />
    </aside>
  );
}

export default Menu;
